import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Fund from 'src/app/interfaces/fund';
import Organization from 'src/app/interfaces/organization';

export type RecipientDialogData = {
  recipient: string | null;
  organization: Organization | null;
  fund: Fund | null;
  type: string | null;
};

@Component({
    selector: 'recipient-dialog',
    templateUrl: './recipient-dialog.component.html',
    styleUrls: ['./recipient-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RecipientDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RecipientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecipientDialogData
  ) {}
  public recipientType: string = '';
  public recipient: string = '';
  selectChanged($event: Event) {
    let target = $event.target as HTMLSelectElement;
    this.data.type = target.selectedOptions[0].value;
  }
  searchChanged(value: string | null) {
    if (this.recipientType === 'Custom' && value) {
      this.recipient = value;
      this.data.recipient = value;
    }
  }
  selectOrg(org: Organization | Fund) {
    switch (this.recipientType) {
      case 'Organization':
        this.data.organization = org as Organization;
        this.recipient = org.name;
        break;
      case 'Fund':
        this.data.fund = org as Fund;
        this.recipient = org.name;
        break;
    }
  }
  closeDialog() {
    this.dialogRef.close({ data: this.data });
  }
}
